/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.add-patient-record-dialog {
  .MuiPaper-root {
    width: 720px;
    height: 440px;
  }

  .title {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  .delete-button {
    color: variables.$color-black;
  }

  .add-patient-dialog-confirmed {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .check-circle {
      width: 52px;
      height: 52px;
    }
  }
}
